module.exports = __webpack_public_path__ + "static/img/about_h5bg_02_zh.5a25909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_02_zh.png
// module id = yRHU
// module chunks = 34